/// <amd-module name="Environments/EnvironmentChecks/Source/EnvironmentsSource" />

import { CommonConstants } from "Environments/EnvironmentsCommon/Constants";
import { getTFSPageData } from "Tfs/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssSecurityService } from "VSS/Platform/Security";

export class EnvironmentsSource {

    public static getInstance(pageContext: IVssPageContext) {
        if (!EnvironmentsSource._instance) {
            EnvironmentsSource._instance = new EnvironmentsSource(pageContext);
        }
        return EnvironmentsSource._instance;
    }

    private constructor(private _pageContext: IVssPageContext) {
        const tfsPageData = getTFSPageData(this._pageContext);
        if (tfsPageData && tfsPageData.project) {
            this._projectId = tfsPageData.project.id;
        }
    }

    public checkAdminPermission(environmentId: string): boolean {
        let token = this._getSecurityToken(environmentId);
        return this._pageContext.getService<IVssSecurityService>("IVssSecurityService").hasPermission(CommonConstants.NamespaceId, token, CommonConstants.AdminPermission);
    }

    private _getSecurityToken(environmentId: string) {
        let token = CommonConstants.Environment.concat(CommonConstants.NamespaceSeparator, this._projectId);
        token = token.concat(CommonConstants.NamespaceSeparator, environmentId);
        
        return token;
    }

    private _projectId: string;
    private static _instance: EnvironmentsSource;
}
